import React, { useState, useEffect } from 'react'
import { Panel, Row, Col } from 'rsuite'
import PanelHeader from '../../components/PanelHeader/PanelHeader'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadSubProjectIncomeRecordAttacthment } from '../../redux/actions/subProjectIncomeRecord'
import notification from '../../utils/notification'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import { getDateThaiShort } from '../../utils/dataUtil'
export default function SubProjectIncomeRecordView({ schema: _schema, ...props }) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTableData, setFileTableData] = useState([])
  const projectCode = sessionStorage.getItem('projectCode')
  const subProjectCode = sessionStorage.getItem('subProjectCode')
  const subProjectPeriod = sessionStorage.getItem('subProjectPeriod')
  const { periodNo, startAndEndDate, periodOfLength } = sessionGetItemObj('subProjectPeriodInfo')
  const [titleLeftStr, setTitleLeftStr] = useState('')
  const [titleRightStr, setTitleRightStr] = useState('')

  useEffect(() => {
    setTitleLeftStr(`งวดที่ ${periodNo || ''} (${startAndEndDate || ''})`)
    setTitleRightStr(`งวดที่ ${periodNo || '0'} / ${periodOfLength || '0'}`)

    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  useEffect(() => {
    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectIncomeRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectIncomeRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<PanelHeader leftString={titleLeftStr} rightString={titleRightStr} />}
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.voucherNumber.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.referenceNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.referenceNumber.value || ''}`}</p>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <p>{formSchema.voucherDate.label}</p>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.voucherDate.value)}`}</p>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.description.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <p>{` : ${formSchema.description.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles.label || 'เอกสารแนบประกอบ'}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <IncomeRecordFileTable
              data={fileTableData}
              deleteable={false}
              onPreview={onPreview}
              onDownload={onDownload}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
